export default __webpack_public_path__ + "static/media/permissions-blocked-chrome.fcbc36ac.svg";